// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DataTable_icon-transition__-yneC {
  transition: transform 0.3s;
}
.DataTable_arrow-position__\\+i4MK {
  top: 50%;
  transform: translateY(-50%);
}
.DataTable_rotate-icon__6y4xH {
  transform: translateY(-50%) rotate(-180deg);
}
`, "",{"version":3,"sources":["webpack://./src/components/Table/DataTable.module.css"],"names":[],"mappings":"AAAA;EAEE,0BAA0B;AAC5B;AACA;EACE,QAAQ;EAER,2BAA2B;AAC7B;AACA;EAEE,2CAA2C;AAC7C","sourcesContent":[".icon-transition {\n  -webkit-transition: transform 0.3s;\n  transition: transform 0.3s;\n}\n.arrow-position {\n  top: 50%;\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.rotate-icon {\n  -ms-transform: translateY(-50%) rotate(-180deg);\n  transform: translateY(-50%) rotate(-180deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon-transition": `DataTable_icon-transition__-yneC`,
	"arrow-position": `DataTable_arrow-position__+i4MK`,
	"rotate-icon": `DataTable_rotate-icon__6y4xH`
};
export default ___CSS_LOADER_EXPORT___;
